import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { Tab, Tabs } from 'foundations-components/transitional/components/TabsTransitionalOld';
import { useMemo } from 'react';
import { DetailsTab } from '../../info/DetailsTab';
import { LegalTab } from '../../info/LegalTab';
import { SupportTab } from '../../info/SupportTab';
import { DetailsPageCard } from './DetailsPageCard';
import { jsx as _jsx } from "react/jsx-runtime";
export function ProductInfoCard({
  details,
  support,
  legal
}) {
  const tabs = useMemo(() => {
    const tabsArray = [];
    if (details) {
      tabsArray.push({
        tabId: 'details',
        title: unescapedText('detailsPage.infoCard.details'),
        content: /*#__PURE__*/_jsx(DetailsTab, Object.assign({}, details))
      });
    }
    if (support) {
      tabsArray.push({
        tabId: 'support',
        title: unescapedText('detailsPage.infoCard.support'),
        content: /*#__PURE__*/_jsx(SupportTab, Object.assign({}, support))
      });
    }
    if (legal) {
      tabsArray.push({
        tabId: 'legal',
        title: unescapedText('detailsPage.infoCard.legal.header'),
        content: /*#__PURE__*/_jsx(LegalTab, Object.assign({}, legal))
      });
    }
    return tabsArray;
  }, [details, support, legal]);
  if (tabs.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(DetailsPageCard, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "detailsPage.infoCard.title"
    }),
    children: tabs.length > 1 ? /*#__PURE__*/_jsx(Tabs, {
      defaultSelected: tabs[0].tabId,
      children: tabs.map(tab => /*#__PURE__*/_jsx(Tab, {
        tabId: tab.tabId,
        title: tab.title,
        children: tab.content
      }, tab.tabId))
    }) : /*#__PURE__*/_jsx("div", {
      children: tabs[0].content
    })
  });
}